<template>
  <Select filterable :selected.sync="selectedId" :data="lists" clearable placeholder="请选择" @updateSelect="fnUpdateSelect()" />
</template>

<script>
import Select from '@/components/Select'
export default {
  name: 'GradeSelector',
  components: {
    Select
  },
  props: {
    selected: {
      type: [Number, String],
      required: true,
      default: 0
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      lists: []
    }
  },
  computed: {
    selectedId: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      }
    }
  },
  watch: {
    data(val) {
      this.lists = val
    }
  },
  created() {
    this.selectedId = this.selected
    this.getList()
  },
  methods: {
    getList() {
      this.$http.getDepartmentList().then(res => {
        res.data.forEach((ele) => {
          ele.label = ele.name
        })
        this.lists = res.data
      })
    },
    fnUpdateSelect(val) {
      this.$emit('updateSelect', val)
    }
  }

}
</script>

  <style scoped>

  </style>
